export class ModalConfirmEvent extends CustomEvent<void> {
  static eventName = 'modal:confirm' as const;

  private constructor() {
    super(ModalConfirmEvent.eventName, {
      bubbles: true,
      cancelable: true,
      composed: true,
    });
  }

  static create() {
    return new ModalConfirmEvent();
  }
}

export class ModalCancelEvent extends CustomEvent<void> {
  static eventName = 'modal:cancel' as const;

  private constructor() {
    super(ModalCancelEvent.eventName, {
      bubbles: true,
      cancelable: true,
      composed: true,
    });
  }

  static create() {
    return new ModalCancelEvent();
  }
}

export class ModalCloseEvent extends CustomEvent<void> {
  static eventName = 'modal:close' as const;

  private constructor() {
    super(ModalCloseEvent.eventName, {
      bubbles: true,
      cancelable: true,
      composed: true,
    });
  }

  static create() {
    return new ModalCloseEvent();
  }
}

export class ModalOpenEvent extends CustomEvent<void> {
  static eventName = 'modal:open' as const;

  private constructor() {
    super(ModalOpenEvent.eventName, {
      bubbles: true,
      cancelable: true,
      composed: true,
    });
  }

  static create() {
    return new ModalOpenEvent();
  }
}
